<template>
    <div>
        
    </div>
</template>

<script type="text/javascript">
const allConfigs = require('../app-config.js');
export default {
    name: 'LogoutView',
    data: function() {
        return {

        };
    },

    mounted: function() {
        this.$confirm('调用成功！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
        }).then(() => {
            let url = allConfigs[process.env.NODE_ENV].apps.MTWEB.returnTo;
            window.location.href = url;
        }).catch(() => {
            let url = allConfigs[process.env.NODE_ENV].apps.MTWEB.returnTo;
            window.location.href = url;      
        });
    },

    methods: {

    }
};
</script>
<style scoped>

</style>

